module.exports = __webpack_public_path__ + "media/images/new-map-81913694.svg";